export enum AssignmentInfoTypes {
  Primary = 'primary',
  Additional = 'additional',
}
